export enum ProductKey {
  INDIVIDUAL_STANDARD_PLAN_RECURRING = 'individual_standard_plan_recurring',
  INDIVIDUAL_STANDARD_PLAN = 'individual_standard_plan',
  COUPLES_STANDARD_PLAN = 'couples_standard_plan',
  COUPLES_STANDARD_PLAN_RECURRING = 'couples_standard_plan_recurring',
  INDIVIDUAL_BASIC_PLAN = 'individual_basic_plan',
  INDIVIDUAL_BASIC_PLAN_RECURRING = 'individual_basic_plan_recurring',
  COUPLES_BASIC_PLAN = 'couples_basic_plan',
  COUPLES_BASIC_PLAN_RECURRING = 'couples_basic_plan_recurring',
  INDIVIDUAL_COMPLETE_PLAN = 'individual_complete_plan',
  INDIVIDUAL_COMPLETE_PLAN_RECURRING = 'individual_complete_plan_recurring',
  COUPLES_COMPLETE_PLAN = 'couples_complete_plan',
  COUPLES_COMPLETE_PLAN_RECURRING = 'couples_complete_plan_recurring',
  INDIVIDUAL_PROFESSIONAL_EXECUTOR_PLAN = 'individual_professional_executor_plan',
  INDIVIDUAL_PROFESSIONAL_EXECUTOR_PLAN_RECURRING = 'individual_professional_executor_plan_recurring',
  COUPLES_PROFESSIONAL_EXECUTOR_PLAN = 'couples_professional_executor_plan',
  COUPLES_PROFESSIONAL_EXECUTOR_PLAN_RECURRING = 'couples_professional_executor_plan_recurring',
  INDIVIDUAL_CUSTOM_PLAN = 'individual_custom_plan',
  INDIVIDUAL_CUSTOM_PLAN_RECURRING = 'individual_custom_plan_recurring',
  COUPLES_CUSTOM_PLAN = 'couples_custom_plan',
  COUPLES_CUSTOM_PLAN_RECURRING = 'couples_custom_plan_recurring',
  INDIVIDUAL_PROTECTION_MANDATE = 'individual_protection_mandate',
  INDIVIDUAL_NOTARIZED_HARD_COPY = 'individual_notarized_hard_copy',
  ADVISOR_PRO = 'advisor_pro', // Temporary key until actual product is added,
  ADVISOR_PRO_ANNUAL = 'advisor_pro_annual', // Temporary key until actual product is added,
  INDIVIDUAL_DIGITAL_VAULT_PLAN = 'individual_digital_vault_plan',
  INDIVIDUAL_DIGITAL_VAULT_PLAN_RECURRING = 'individual_digital_vault_plan_recurring',
  ADD_ON_INDIVIDUAL_SECONDARY_WILL = 'add_on_individual_secondary_will',
  ADD_ON_COUPLES_SECONDARY_WILL = 'add_on_couples_secondary_will',
  DIGITAL_VAULT_DOC_BUILDER_BASIC = 'digital_vault_doc_builder_basic',
  DIGITAL_VAULT_DOC_BUILDER_ONLINE_WILL = 'digital_vault_doc_builder_online_will',
}
